import PubSub from "underpub-js";
import Slick from "slick-carousel";
import Equalizer from "../../../../scripts/classes/Equalizer";

var ContentImageSlideshowLeft = function(options) {

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

ContentImageSlideshowLeft.prototype.init = function() {

	var self = this;

	// sliders
	this.$imageSlider = this.options.$el.find('.image-slider')
	this.$captionsSlider = this.options.$el.find('.slide-captions-slider')

	// initialize image slider
	this.$imageSlider.slick({
		arrows: false,
		fade: true,
		speed: 750,
		autoplay: false,
		asNavFor: self.$captionsSlider[0],
	});

	this.$imageSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
	
		self.updateSlideCounter(nextSlide + 1);
		self.updateSlideContent(nextSlide + 1);

		if (self.options.$el.find('.play-pause-btn-wrapper .play-pause-btn').hasClass('playing'))
		{
			self.restartCountdown();
		}

	});

	// initialize caption slider
	this.$captionsSlider.slick({
		arrows: false,
		fade: true,
		speed: 750,
		autoplay: false,
		asNavFor: self.$imageSlider[0],
	});

	// set up equalizer to set height of slide counter container because children are position: absolute
	this.slideCounterEq = new Equalizer( self.options.$el.find('.slide-counter, .slide-counter .slide-number') );

	this.slideCounterEq.equalizeHeights();

	PubSub.subscribe("resized", function(){
		self.slideCounterEq.equalizeHeights();
	});

	// play/pause button click
	this.options.$el.find('.play-pause-btn').on('click', function() {
		if ($(this).hasClass('playing'))
		{
			self.options.$el.find('.play-pause-btn').removeClass('playing');
			self.options.$el.find('.play-pause-btn').addClass('paused');
			self.pauseSlider();
		}
		else if ($(this).hasClass('paused'))
		{
			self.options.$el.find('.play-pause-btn').removeClass('paused');
			self.options.$el.find('.play-pause-btn').addClass('playing');
			self.playSlider();
		}

	});

	this.startCountdown();

};

ContentImageSlideshowLeft.prototype.restartCountdown = function() {

	this.stopCountdown();
	this.startCountdown();

};

ContentImageSlideshowLeft.prototype.stopCountdown = function() {

	clearInterval(this.countdownInterval);

};

ContentImageSlideshowLeft.prototype.startCountdown = function() {

	var self = this;

	this.startCountdownAnimation();

	this.countdownInterval = window.setInterval(function() {
		self.$imageSlider.slick('slickNext');
		self.startCountdownAnimation();
	}, 8000);
};

ContentImageSlideshowLeft.prototype.startCountdownAnimation = function() {

	// reset the animation by removing and re-adding the play/pause button
	var $origEl = this.options.$el.find('.play-pause-btn').first();

	var $newEl = $origEl.clone(true);

	$newEl.removeClass('playing');

	// remove the existing element
	$origEl.remove();

	// add the new element
	this.options.$el.find('.play-pause-btn-wrapper').append($newEl);

	// add the playing class to kick off the animation
	this.options.$el.find('.play-pause-btn').addClass('playing');

};

ContentImageSlideshowLeft.prototype.pauseSlider = function() {
	this.options.$el.find('.play-pause-btn').removeClass('play');
	this.options.$el.find('.play-pause-btn').removeClass('playing');
	this.options.$el.find('.play-pause-btn').addClass('paused');
	this.stopCountdown();
};

ContentImageSlideshowLeft.prototype.playSlider = function() {
	this.options.$el.find('.play-pause-btn').removeClass('paused');
	this.options.$el.find('.play-pause-btn').addClass('playing');
	this.options.$el.find('.play-pause-btn').addClass('play');
	this.startCountdown();
};

ContentImageSlideshowLeft.prototype.updateSlideCounter = function(slideNumber){

	var self = this;

	this.options.$el.find('.slide-number').removeClass('active');

	this.options.$el.find('.slide-number[data-slide-number="' + slideNumber + '"]').addClass('active');

};

ContentImageSlideshowLeft.prototype.updateSlideContent = function(slideNumber){

	var self = this;

	this.options.$el.find('.slide-number').removeClass('active');

	this.options.$el.find('.slide-number[data-slide-number="' + slideNumber + '"]').addClass('active');

};

export default ContentImageSlideshowLeft;
